export const SET_INCIDENT_COUNTS_BY_STATUS = 'SET_INCIDENT_COUNTS_BY_STATUS';

export const setIncidentCountsByStatus = (incidentCounts: any) => (dispatch: any) => {
  dispatch({ type: SET_INCIDENT_COUNTS_BY_STATUS, payload: incidentCounts });
};
